var map = {
	"./PAP_cat_icon_1-to-1.svg": 1102,
	"./PAP_cat_icon_blog-theme-design.svg": 3033,
	"./PAP_cat_icon_book-cover-design.svg": 3034,
	"./PAP_cat_icon_brochure-or-menu-design.svg": 3035,
	"./PAP_cat_icon_business-card-design.svg": 3036,
	"./PAP_cat_icon_business-tagline.svg": 3037,
	"./PAP_cat_icon_design-consultation.svg": 1103,
	"./PAP_cat_icon_email-design.svg": 3038,
	"./PAP_cat_icon_icon-button-and-widget-design.svg": 3039,
	"./PAP_cat_icon_illustration-and-graphic-design.svg": 3040,
	"./PAP_cat_icon_infographics-design.svg": 3041,
	"./PAP_cat_icon_landing-page-design.svg": 3042,
	"./PAP_cat_icon_letterhead-and-stationery-design.svg": 3043,
	"./PAP_cat_icon_logo-and-business-card-design.svg": 3044,
	"./PAP_cat_icon_logo-and-social-media-assets-design.svg": 3045,
	"./PAP_cat_icon_logo-design.svg": 1104,
	"./PAP_cat_icon_magazine-cover-design.svg": 3046,
	"./PAP_cat_icon_merchandise-design.svg": 3047,
	"./PAP_cat_icon_mobile-ui-design.svg": 3048,
	"./PAP_cat_icon_naming-a-business-or-product.svg": 3049,
	"./PAP_cat_icon_other-clothing-design.svg": 3050,
	"./PAP_cat_icon_outdoor-or-signage-design.svg": 3051,
	"./PAP_cat_icon_package-graphics.svg": 3052,
	"./PAP_cat_icon_packaging-design.svg": 3053,
	"./PAP_cat_icon_postcard-or-flyer-design.svg": 3054,
	"./PAP_cat_icon_poster-design.svg": 3055,
	"./PAP_cat_icon_presentation-design.svg": 3056,
	"./PAP_cat_icon_product-design.svg": 3057,
	"./PAP_cat_icon_social-media-assets-design.svg": 3058,
	"./PAP_cat_icon_t-shirt-design.svg": 3059,
	"./PAP_cat_icon_tattoo-design.svg": 3060,
	"./PAP_cat_icon_vehicle-wrap-design.svg": 3061,
	"./PAP_cat_icon_wall-mural-art-design.svg": 3062,
	"./PAP_cat_icon_web-banner-design.svg": 3063,
	"./PAP_cat_icon_website-design.svg": 3064
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 242;



//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/pap ^\.\/PAP_cat_icon_.*\.svg$
// module id = 242
// module chunks = 2